<script lang="ts">
  import { onMount } from "svelte";

  export let setData: (name: string, value: string) => void;
  export let name: string = "code";
  export let isError: boolean = false;
  export let value: string = "";
  export let errorMessage: string = "Incorrect Verification Code";

  const elems: ("input" | "hyphen")[] = ["input", "input", "input", "input", "input", "input"];
  let verificationCodeElement: HTMLElement;
  let inputs: HTMLInputElement[];
  let activeIndex: number = -1;
  let inputsLength: number = -1;

  function updateCodeValue() {
    let code: string = "";
    for (let i = 0; i < inputs.length; i++) {
      code += inputs[i].value;
    }

    value = code;
    setData(name, value);
  }

  function isValueValid(s: string): boolean {
    return /^[0-9]$/i.test(s);
  }

  function getInputIndex(inputElement: HTMLInputElement) {
    return inputs.indexOf(inputElement);
  }

  function handleFocus(event: Event) {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    activeIndex = getInputIndex(target);
  }

  function handleBlur() {
    activeIndex = -1;
  }

  function focusNextInput() {
    if (activeIndex < inputsLength - 1) {
      inputs[activeIndex + 1].focus();
    }
  }

  function focusPrevInput() {
    if (activeIndex > 0) {
      inputs[activeIndex - 1].focus();
    }
  }

  function changeValueAtActiveIndex(value: string) {
    inputs[activeIndex].value = value;
    updateCodeValue();
  }

  function handleKeydown(event: KeyboardEvent) {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    const key = event.key;

    if (key === "Backspace") {
      if (target.value == "") {
        focusPrevInput();
      } else {
        changeValueAtActiveIndex("");
      }
    } else if (key === "ArrowLeft") {
      focusPrevInput();
    } else if (key === "ArrowRight") {
      focusNextInput();
    }
  }

  function handleInput(event: Event) {
    const e: InputEvent = event as InputEvent;
    const target: HTMLInputElement = event.target as HTMLInputElement;

    if (isValueValid(e.data)) {
      target.value = e.data;
    } else {
      target.value = "";
    }

    if (target.value !== "") {
      focusNextInput();
    }

    updateCodeValue();
  }

  function handlePaste(event: ClipboardEvent) {
    event.preventDefault();

    const data = event.clipboardData
      .getData("text/plain")
      .slice(0, inputsLength - activeIndex)
      .split("");

    if (!data.every((v) => isValueValid(v))) {
      return;
    }

    for (let i = 0; i < data.length; i++) {
      inputs[activeIndex + i].value = data[i];
    }

    updateCodeValue();
  }

  onMount(() => {
    inputs = Array.from(verificationCodeElement.querySelectorAll("input"));
    inputsLength = inputs.length;
    setData(name, "");
  });
</script>

<div
  bind:this={verificationCodeElement}
  class="relative flex flex-row items-center gap-1.5 flex-wrap"
>
  {#each elems as elem}
    {#if elem === "input"}
      <input
        type="number"
        on:keydown={handleKeydown}
        on:input={handleInput}
        on:focus={handleFocus}
        on:blur={handleBlur}
        on:paste={handlePaste}
        on:change={updateCodeValue}
      />
    {:else}
      <span>-</span>
    {/if}
  {/each}

  {#if isError}
    <div
      class="absolute px-5 py-2.5 rounded-md bg-tertiary-error bg-opacity-10 text-tertiary-error font-medium"
      style="top: calc(100% + 10px); left: 0px; right: 0px;"
    >
      {errorMessage}
    </div>
  {/if}
</div>

<style lang="postcss">
  input {
    @apply outline-none box-border rounded border border-solid border-light-100 text-center text-dark-300 font-semibold;
    width: 52px;
    height: 70px;
    font-size: 28px;
    caret-color: transparent;
  }

  input:focus {
    @apply border-primary-datadocs-blue bg-primary-datadocs-blue bg-opacity-5;
  }

  span {
    @apply font-medium px-0.5 text-dark-50;
    font-size: 20px;
  }

  @media (max-width: 500px) {
    input {
      width: 36px;
      height: 50px;
      font-size: 20px;
    }
  }
</style>
